import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { RoutingProfileAction } from '../routingProfile.action';

type IDependencies = IClientApiDependencySegment;

export const removeRoutingProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(RoutingProfileAction.remove.started),
  mergeMap((params) => {
    return dependencies.api.deleteRoutingProfile({ id: params.routingProfileId }).pipe(
      mergeMap(() => {
        return [
          RoutingProfileAction.remove.done({ params }),
        ];
      }),
      catchApiError((error) => {
        return [
          RoutingProfileAction.remove.failed({ params, error }),
          createApiErrorNotification(error),
        ];
      }),
    );
  }),
);
